import React from "react";
import { MenuItem, ListItemIcon } from "@mui/material";

import { Icon } from "../../icons";
import { Menu, Button } from "..";
import { ManageBookingMenuContainer } from "./ManageBookingMenu.styles";
import { useModal, Modals } from "../../contexts/ModalContext";
import { UserBookingInterest } from "../../models/BookingInterest";

export interface CustomVariantManageBookingMenuProps {
  setBookingData: Function;
  disableEdit: boolean;
  onModalAction?: (successful?: boolean, message?: React.ReactElement | string) => void;
}

export const ManageBookingMenu = ({
  setBookingData,
  disableEdit,
  onModalAction,
  ...rest
}: CustomVariantManageBookingMenuProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { openModal } = useModal();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditGuestDetails = () => {
    setBookingData()
    openModal(Modals.EditGuestDetails, onModalAction)
  };

  const handleRemoveTickets = () => {
    setBookingData()
    openModal(Modals.RemoveTickets, onModalAction)
  };

  return (
    <>
      <ManageBookingMenuContainer data-cy="account-menu-container">
        <Button
          data-cy="manage-booking-button"
          variant="primary"
          size="sm"
          gradientStyle="gradient3"
          onClick={handleClick}
          aria-controls={open ? "ManageBookingMenu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          EDIT TICKETS
        </Button>
      </ManageBookingMenuContainer>

      <Menu
        data-cy="manage-booking-menu"
        anchorEl={anchorEl}
        id={"ManageBookingMenu"}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        elevation={0}
        MenuListProps={{ sx: { padding: 0 } }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleRemoveTickets} data-cy="manage-booking-menu-remove-tickets">
          <ListItemIcon>
            <Icon icon="Ticket" />
          </ListItemIcon>
          Remove Tickets
        </MenuItem>
        <MenuItem onClick={handleEditGuestDetails} data-cy="manage-booking-edit-guest-details" disabled={disableEdit}>
          <ListItemIcon>
            <Icon icon="UserGroup" />
          </ListItemIcon>
            Edit Guest Details
        </MenuItem>
      </Menu>
    </>
  );
};

export interface ManageBookingMenuProps
  extends React.ComponentProps<typeof ManageBookingMenu> {
  as?: React.ElementType;
}

ManageBookingMenu.displayName = "ManageBookingMenu";